<div #imprintPage id="imprintPage" class="page">
  <h1 data-translate="IMPRINT.TITLE"></h1>
  <br>
  <h2 data-translate="IMPRINT.LEGAL.HEADING"></h2>
  <p>
    <strong data-translate="IMPRINT.LEGAL.NAME"></strong><br>
    <span data-translate="IMPRINT.LEGAL.ROLE"></span><br>
    <span data-translate="IMPRINT.LEGAL.ADDRESS.LINE1"></span><br>
    <span data-translate="IMPRINT.LEGAL.ADDRESS.LINE2"></span><br>
    <span data-translate="IMPRINT.LEGAL.ADDRESS.COUNTRY"></span>
  </p>
  <br>
  <h2 data-translate="IMPRINT.CONTACT.HEADING"></h2>
  <p>
    <span data-translate="IMPRINT.CONTACT.PHONE"></span><br>
    <span data-translate="IMPRINT.CONTACT.EMAIL_LABEL"></span>
    <a href="mailto:{{ translate.instant('IMPRINT.CONTACT.EMAIL') }}">
      <span data-translate="IMPRINT.CONTACT.EMAIL"></span>
    </a>
  </p>
  <br>
  <h2 data-translate="IMPRINT.VAT.HEADING"></h2>
  <p data-translate="IMPRINT.VAT.CONTENT"></p>
  <br>
  <h2 data-translate="IMPRINT.RESPONSIBLE.HEADING"></h2>
  <p>
    <span data-translate="IMPRINT.RESPONSIBLE.NAME"></span><br>
    <span data-translate="IMPRINT.RESPONSIBLE.ADDRESS_REF"></span>
  </p>
  <br>
  <h2 data-translate="IMPRINT.DISCLAIMER.HEADING"></h2>
  <p data-translate="IMPRINT.DISCLAIMER.CONTENT"></p>
  <br>
  <h2 data-translate="IMPRINT.COPYRIGHT.HEADING"></h2>
  <p data-translate="IMPRINT.COPYRIGHT.CONTENT"></p>
  <br>
  <h2 data-translate="IMPRINT.CREDITS.HEADING"></h2>
  <p>
    <span data-translate="IMPRINT.CREDITS.PART1"></span><br>
    <span data-translate="IMPRINT.CREDITS.PART2"></span><br>
    <span data-translate="IMPRINT.CREDITS.PART3"></span>
  </p>
</div>
